<template>
  <div>
    <div
      v-if="params.data.type === 'File'"
      @click="getFile(params.data.file_url, params.data.name)"
    >
      <img src="../../../../assets/download-icon.svg" class="pr-2 icon" />
    </div>
    <div
      v-if="params.data.type === 'Folder'"
      @click="downloadFolder(params.data.folder_file)"
    >
      <img src="../../../../assets/download-icon.svg" class="pr-2 icon" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  methods: {
    getFile(url, title) {
      console.log("url", url);
      axios({
        method: "get",
        url,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, title);
        })
        .catch(() => console.log("error occured"));
    },
    forceFileDownload(response, title) {
      console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async downloadFolder(files) {
      console.log("files", files);
      for await (const file of files) {
        await this.timeout(500);
        this.getFile(file.url, file.name);
      }
    },
  },
  mounted() {
    console.log(this.params.data);
  },
};
</script>
<style scoped>
.icon {
  cursor: pointer;
}
</style>
